import styled from 'styled-components'

// Components
import { Icon } from 'components/icon'
import { Pill } from 'components/pill/Pill'

export const HistoryContainer = styled.div`
  margin: var(--size-extra-large) 0px;
  min-height: 600px;
`
export const UnderConstructionIcon = styled(Icon)`
  font-size: 200px;
`
export const UnderConstructionText = styled.div`
  font-size: 30px;
  margin-top: var(--size-medium);
  text-align: center;
`

export const ReturnContainer = styled(Pill)`
  margin: var(--size-medium) 0px;
  width: fit-content;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: var(--font-medium);
  border: solid 1px var(--neutral-lighter);
  background: var(--neutral-light);

  &:hover {
    background: var(--neutral-lighter);
  }

  &:active {
    background: var(--neutral-light);
  }

  &:focus {
    box-shadow: var(--focus-shadow);
  }

  span {
    margin-right: var(--size-small);
    font-size: var(--font-large);
  }
`
export const BlockLink = styled.a`

`

export const HistoryTitle = styled.div`
  vertical-align: top;
  font-weight: var(--font-weight-semi-bold);
  font-size: 22px;
  margin-bottom: var(--size-medium);
`

export const EpochsList = styled.div`
 display: flex;
 flex-direction: column;
`
export const EpochItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 10px;
  border: solid 1px var(--neutral-lighter);
  background: var(--neutral-light);
  border-radius: 10px;
  display: table;
  border-collapse: separate; 
  border-spacing: 0px 5px;
`

export const EpochTitle = styled.div`
  font-weight: var(--font-weight-semi-bold);
  display: table-row;
  font-size: var(--font-large);
`

export const EpochDataRow = styled.div`

`

export const EpochData = styled.div`
   width: 33%;
   display: table-cell;
   text-align: center;
   font-size: var(--font-medium);
   @media (max-width: 925px) {
        width: 100%;
        display: block;
        text-align: left;
        margin-top: 7px;
        margin-left: 15px;
   }
`

export const Bold = styled.b`
   font-weight: var(--font-weight-semi-bold);
`